/**
 * Kart-telefon doğrulamasının hangi ödeme bilgileri için başlatıldığını tutar.
 *
 * "Onayla" her basışta yeni bir ödeme onay kaydı (paymentControl) açar; doğrulama ise
 * açıldığı kayda bağlıdır. Bayi pop-up'ı kapatıp yeniden "Onayla"ya basınca yeni kayıt
 * açılıyor, kod eski kayda giriliyor ve ödeme en yeni kayda baktığı için reddediliyordu.
 * Bilgiler değişmediyse açık doğrulamaya dönülür; değiştiyse (ör. taksit) müşteri başka
 * bir ödemeye onay vermiş olur, yeni doğrulama başlar.
 */
export interface ICardPhonePaymentInput {
  paymentType: number
  company: string
  amount: number
  cardNumber: string
  isIncluded: number
  paymentTermsId: number
  installment: number
  // Bayi adına (remote) ödemede ödemenin yapıldığı bayi; normal akışta boş.
  dealerCode: string
}

export interface ICardPhoneSession {
  paymentControlId: number
  fingerprint: string
}

export const cardPhoneFingerprint = (input: ICardPhonePaymentInput): string =>
  JSON.stringify([
    input.paymentType,
    input.company,
    Number(input.amount),
    input.cardNumber,
    input.isIncluded,
    input.paymentTermsId,
    input.installment,
    input.dealerCode,
  ])

/** Açık bir doğrulama var ve aynı ödeme bilgileri için mi başlatıldı? */
export const canResumeCardPhoneSession = (session: ICardPhoneSession, fingerprint: string): boolean =>
  session.paymentControlId > 0 && session.fingerprint !== '' && session.fingerprint === fingerprint
